/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuRadioSelectSearch_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_viewer">;
    readonly " $refType": "SbSharedRefineMenuRadioSelectSearch_viewer";
};
export type SbSharedRefineMenuRadioSelectSearch_viewer$data = SbSharedRefineMenuRadioSelectSearch_viewer;
export type SbSharedRefineMenuRadioSelectSearch_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuRadioSelectSearch_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectSearch_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7f4ab4b9bb82a100a696e1ed031ed2e1';
export default node;
